import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=dd8eb1d4&scoped=true"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"
import style0 from "./deposit.vue?vue&type=style&index=0&id=dd8eb1d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8eb1d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd8eb1d4')) {
      api.createRecord('dd8eb1d4', component.options)
    } else {
      api.reload('dd8eb1d4', component.options)
    }
    module.hot.accept("./deposit.vue?vue&type=template&id=dd8eb1d4&scoped=true", function () {
      api.rerender('dd8eb1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/deposit/deposit.vue"
export default component.exports